import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { FoljaZgjedhimi, FoljaLlojiTemes, FoljaKoha, FoljaForma, FoljaNumri, FoljaVeta } from '@core/enums/folja.enum';
import { FoljaConstants } from '@core/globals/folja/folja.constants';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';

@Injectable({
  providedIn: 'root',
})
export class FoljaUrdheroreFormulaService {
  constructor(private fb: UntypedFormBuilder) { }

  generateFormula(baza: string, foljaBaza: FoljaBaza, formArray: UntypedFormArray) {
    if (!foljaBaza.zgjedhimiId || !foljaBaza.llojiTemesId) {
      throw new Error('Zgjedhimi dhe lloji i temes jane te zbrazeta.');
    }

    const ctrls = this.getFormulaControls(
      baza,
      foljaBaza.zgjedhimiId,
      foljaBaza.llojiTemesId,
      foljaBaza.f1,
      foljaBaza.f1a,
      foljaBaza.f1b,
      foljaBaza.f2,
      foljaBaza.f3,
      foljaBaza.f3a,
      foljaBaza.f3b,
      foljaBaza.f4,
      foljaBaza.f5,
      foljaBaza.f6,
      foljaBaza.f6a,
      foljaBaza.f6b,
      foljaBaza.f7,
      foljaBaza.f8,
    );

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    ctrls.forEach((f) => {
      this.setFormula(formArray, f.kohaId, f.formaId, f.vetaId, f.numriId, f.pershkrimi, f.renditja);
    });
  }

  getFormulaControls(
    baza: string,
    zgjedhimi: FoljaZgjedhimi,
    llojiTemes: FoljaLlojiTemes,
    f1: string,
    f1a: string,
    f1b: string,
    f2: string,
    f3: string,
    f3a: string,
    f3b: string,
    f4: string,
    f5: string,
    f6: string,
    f6a: string,
    f6b: string,
    f7: string,
    f8: string
  ): { kohaId: number; formaId: number; vetaId: number; numriId: number; pershkrimi: string; renditja: number }[] {
    const ctrls: any[] = [];
    const formulas = FoljaConstants.GetFormulas(baza, zgjedhimi, llojiTemes);

    // TODO: Remove them completely
    let veprore = true;
    let joveprore = true;
    let njejes = true;
    let shumes = true;

    switch (zgjedhimi) {
      case FoljaZgjedhimi.I: {
        switch (llojiTemes) {
          // Punoj
          case FoljaLlojiTemes.MeTemeO: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Rrëfej
          case FoljaLlojiTemes.MeTemeE: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Shkruaj
          case FoljaLlojiTemes.MeTemeUA: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'j', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3b + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3b + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Lyej
          case FoljaLlojiTemes.MeTemeYE: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'j', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3b + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3b + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Blej
          case FoljaLlojiTemes.KanTeNjejtenTeme: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Arrij
          case FoljaLlojiTemes.ZgjerimTemeMT: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'j', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Mbaj
          case FoljaLlojiTemes.ZgjerimTemeMJT: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'j', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Ruaj
          case FoljaLlojiTemes.MeTemeUAdheZgjerimTemeMeJT: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'j', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3b + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3b + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Bëj
          case FoljaLlojiTemes.ZgjerimTemeMR: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'j', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
        }

        break;
      }
      case FoljaZgjedhimi.II: {
        switch (llojiTemes) {
          //Hap
          case FoljaLlojiTemes.KanTeNjejtenTeme: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          //Mas/Mat
          case FoljaLlojiTemes.FoljeMeDysoreNeDisaFormaTS: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1a, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1a + 'ni', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1b + 'ni', renditja: 2 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1a + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1a + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          //Mas
          case FoljaLlojiTemes.MasFoljeDysore1MeS: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f2, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f2 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f2 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          //Mat
          case FoljaLlojiTemes.MatFoljeDysore2MeT: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          //Dredh
          case FoljaLlojiTemes.MeTemeE: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Nxjerr
          case FoljaLlojiTemes.MeTemeJE1: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Pjek
          case FoljaLlojiTemes.MeTemeJE2: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Djeg
          case FoljaLlojiTemes.MeTemeJE3: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Dal
          case FoljaLlojiTemes.MeTemeA1: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Marr
          case FoljaLlojiTemes.MeTemeA2: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f2, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f2 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f2 + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f2 + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Përkas
          case FoljaLlojiTemes.FoljetMeTemeTeZgjeruarTeTipitPerkas: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3a, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3a + 'ni', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3b + 'ni', renditja: 2 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3a + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3a + 'uni', renditja: 1 });
            //#endregion
            break;
          }
          // Shkas
          case FoljaLlojiTemes.FoljetShkasVrasNgasDheGergas: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3a, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f4, renditja: 2 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3a + 'ni', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3b + 'ni', renditja: 2 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f4 + 'ni', renditja: 3 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3a + 'u', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3a + 'uni', renditja: 1 });
            //#endregion
            break;
          }
        }

        break;
      }
      case FoljaZgjedhimi.III: {
        switch (llojiTemes) {
          // Vë
          case FoljaLlojiTemes.NeTeKryerenEThjeshteNjejesMeTemeTeZgjeruarMeR: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'r', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Di
          case FoljaLlojiTemes.NeTeKryerenEThjeshteDheNePjesoreEZgjerojneTemenMePrapashtesenT: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f1 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Pi
          case FoljaLlojiTemes.FoljaPi: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f1, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
          // Shtie
          case FoljaLlojiTemes.FoljaShtie: {
            //#region formula
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f8, renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'ni', renditja: 1 });

            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, pershkrimi: f3 + 'hu', renditja: 1 });
            ctrls.push({ kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, pershkrimi: f3 + 'huni', renditja: 1 });
            //#endregion
            break;
          }
        }

        break;
      }
      case FoljaZgjedhimi.PaRregullt: {
        switch (llojiTemes) {
          // Jam
          case FoljaLlojiTemes.Supletive: {
            break;
          }
          // Them
          case FoljaLlojiTemes.Josupletive: {
            break;
          }
        }

        break;
      }
    }

    return ctrls;
  }

  private setFormula(formArray: UntypedFormArray, koha: FoljaKoha, forma: FoljaForma, veta: FoljaVeta, numri: FoljaNumri, value: string, renditja: number) {
    let fg = formArray.controls.find(
      (c) => c.get('kohaId')?.value == koha && c.get('formaId')?.value == forma && c.get('vetaId')?.value == veta && c.get('numriId')?.value == numri && c.get('renditja')?.value == renditja
    ) as UntypedFormGroup;
    if (fg) fg.get('pershkrimi')?.setValue(value);
    else {
      let fg = this.fb.group({
        kohaId: koha,
        formaId: forma,
        vetaId: veta,
        numriId: numri,
        pershkrimi: value,
        renditja: renditja
      });
      if (formArray.disabled) fg.disable();
      formArray.push(fg);
    }
  }
}
